import React, { useState, useRef, useEffect } from "react";
import { FaPlay, FaMicrophone, FaVolumeLow, FaCheck } from "react-icons/fa6";
import { motion, AnimatePresence } from "framer-motion";
import { useLiveTutor } from "../../../hooks/LiveTutorProvider";

interface FixedConversationProps {
	dialogue: any[];
}

const FixedConversation: React.FC<FixedConversationProps> = ({ dialogue }) => {
	dialogue = dialogue.map((line) => ({
		role: line.role || line.speaker,
		content: line.line || line.content,
	}));

	const {
		addActiveState,
		removeActiveState,
		exerciseInfoRef,
		actionHandler,
		callbackRef,
		handleChat,
	} = useLiveTutor();
	const [currentLineIndex, setCurrentLineIndex] = useState<number>(0);
	const currentLineIndexRef = useRef<number>(currentLineIndex);
	const currentResponse = useRef<string>("");
	const messagesEndRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		exerciseInfoRef.current = {
			conversation: dialogue,
			current_line: currentLineIndex,
			text: dialogue[currentLineIndex].content,
		};
		console.log(exerciseInfoRef.current);
		actionHandler.current["next_line"] = handleNext;

		/*callbackRef.current = (response: string) => {
			const dialogueLine = dialogue[currentLineIndexRef.current].content
				.replace(/\s/g, "")
				.toLowerCase();
			currentResponse.current += response.replace(/\s/g, "").toLowerCase();

			if (currentResponse.current.includes(dialogueLine)) {
				currentResponse.current = "";
				handleNext();
			}
		};*/

		(async () => {
			await handleChat("Read the instruction/question.", false);
			addActiveState("pronunciation");
		})();

		return () => {
			exerciseInfoRef.current = null;
			actionHandler.current["next_line"] = null;
			callbackRef.current = null;
			removeActiveState("pronunciation");
		};
	}, []);

	useEffect(() => {
		if (currentLineIndex >= dialogue.length) {
			return;
		}
		exerciseInfoRef.current.current_line = currentLineIndex;
		exerciseInfoRef.current.text = dialogue[currentLineIndex].content;
		currentLineIndexRef.current = currentLineIndex;
		scrollToBottom();
	}, [currentLineIndex]);

	const handleNext = () => {
		setCurrentLineIndex((prev) => prev + 1);
		/*callbackRef.current = (response: string) => {
			handleNext();
			callbackRef.current = null;
		};*/
	};

	const scrollToBottom = () => {
		if (messagesEndRef.current) {
			messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
		}
	};

	return (
		<div className="max-w-2xl mx-auto p-6 w-full md:w-4/5 bg-white rounded-lg shadow-lg overflow-y-visible max-h-[500px]">
			<div className="space-y-4">
				<AnimatePresence>
					{dialogue.slice(0, currentLineIndex + 1).map((line, index) => (
						<motion.div
							key={index}
							initial={{ opacity: 0, y: 20 }}
							animate={{ opacity: 1, y: 0 }}
							exit={{ opacity: 0, y: -20 }}
							transition={{ duration: 0.3 }}
							className={`p-4 rounded-lg ${
								index === currentLineIndex
									? "bg-yellow-100 border-2 border-yellow-300"
									: "bg-gray-100"
							}`}
						>
							<div className="flex justify-between items-center mb-2">
								<span className="font-bold text-gray-700">{line.role}</span>
								{index < currentLineIndex && (
									<FaCheck className="text-green-500" />
								)}
							</div>
							<p className="text-gray-600">{line.content}</p>
						</motion.div>
					))}
				</AnimatePresence>
				<div ref={messagesEndRef} />
			</div>
		</div>
	);
};

export default FixedConversation;
